module.exports = __webpack_public_path__ + "img/auto-trader-investimento-T.6150d984.png";